import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavTab } from './components/NavTab';

class Navbar extends React.Component {
  renderLogin() {
    const { isLoggedIn, currentPage } = this.props;
    if (isLoggedIn) {
      return <a className='nav-item is-tab' href='/logout'>Logout</a>;
    } else {
      return <NavTab
        show={true}
        url='/login'
        text='Login'
        isActive={currentPage === 'login'} />;
    }
  }

  render() {
    const { isLoggedIn, currentPage } = this.props;
    return <nav className='nav has-shadow'>
      <div className='container main-header'>
        <div className='nav-left'>
          <a className='nav-item' href="/categories">
            <img className='md-logo' src='/assets/img/logo.png' alt='logo' />
          </a>
          <NavTab
            show={isLoggedIn}
            url='/categories'
            text='Categories'
            isActive={currentPage === 'categories'} />
          <NavTab
            show={isLoggedIn}
            url='/search'
            text='Search'
            isActive={currentPage === 'search'} />
        </div>
        <span id='nav-toggle' className='nav-toggle'>
          <span></span>
          <span></span>
          <span></span>
        </span>
        <div id='nav-menu' className='nav-right nav-menu'>
          <NavTab
            show={true}
            url='https://www.cir2.com/'
            text='Cambridge'
            isActive={currentPage === 'cambridge'} />
          <NavTab
            show={true}
            url='/help'
            text='Help'
            isActive={currentPage === 'help'} />
          <NavTab
            show={isLoggedIn}
            url='/profile'
            text='Profile'
            isActive={currentPage === 'profile'} />
          <NavTab
            show={!isLoggedIn}
            url='/forgotPassword'
            text='Forgot password?'
            isActive={currentPage === 'forgotPassword'} />
          {this.renderLogin()}
        </div>
      </div>
    </nav>;
  }
}

Navbar.propTypes = {
  currentPage: PropTypes.string,
  isLoggedIn: PropTypes.bool
};

export default connect(null)(Navbar);



// WEBPACK FOOTER //
// ./src/common/components/navbar/Navbar.jsx